var map = {
	"./banner_bg_img.png": "db18",
	"./pass_bg_img.png": "80b6",
	"./pic_hhyw_img.png": "6be5",
	"./pic_hhzw_img.png": "fc27",
	"./zjcx_fail_bg_img.png": "e4b4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6d7c";